<div class="radialWrapper">
  <div class="circle" (mousedown)="onStartDrag($event)" (touchstart)="onStartDrag($event)">
    <sn-icon
      class="camera-icon"
      [fontSet]="fontSet"
      [fontIcon]="fontIcon"
      [size]="size"
      [style.color]="color"
    ></sn-icon>
    <div class="dot" (mousedown)="onDotStart($event)" (mouseup)="onDotEnd($event)"></div>
  </div>
  <div class="camera-angle" *ngIf="showDegrees">{{ angle }}<span>&#176;</span></div>
</div>
